import { render } from "./HeroSlider.vue?vue&type=template&id=1eda4b0a"
import script from "./HeroSlider.vue?vue&type=script&lang=js"
export * from "./HeroSlider.vue?vue&type=script&lang=js"

import "./HeroSlider.vue?vue&type=style&index=0&id=1eda4b0a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__